module.exports = __webpack_public_path__ + "95b89061864f391c816c5ef87c36da60.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/E@2x.png
// module id = 830
// module chunks = 0